/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import Typewriter from '../../CommonComponents/TypeWriting';
import { useDispatch, useSelector } from 'react-redux';
import { isStreamingStarted, loader } from '../../Services/Redux/Reducers/commonSlice';

function APIErrorHandling(props) {
    const [isOverviewTextLoading, setIsOverviewTextLoading] = useState(false);
    const conList = useSelector((state) => state?.chat?.conversationList ?? []);
    const dispatch = useDispatch();
    const loading = useSelector((state) => state?.common?.isLoader ?? false);

    useEffect(() => {
        if (props.index === conList.length - 1 && loading && isOverviewTextLoading) {
            dispatch(isStreamingStarted(false));
            dispatch(loader(false));
        }
    }, [props.isAnswerComplete, loading, isOverviewTextLoading, conList.length, dispatch])

    return (
        <div>
            <div className="TextResponse">
                <div className="col-11 chat_options d-flex flex-column mb response_bg">
                    <div className="generic-error-txt bad-intent-error">
                        <Typewriter convoId={props.convoId} type="responseText" text={"Unable to process your request. Please try again."} delay={props.delay} isAnswerComplete={props.isAnswerComplete} setLoading={setIsOverviewTextLoading} effects={props.effects} responseType='Error' />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default APIErrorHandling;